import type { ToolExecution } from '@hooks/useChat';

/** Approval requests and delivered artifacts stay visible; everything else folds into the trail. */
export const isTrailStep = (tool: ToolExecution): boolean =>
  tool.status !== 'pending_approval' && !tool.artifactInfo;
